module.exports = __webpack_public_path__ + "img/profile.a05bdbdf.png";